import { EDoorWindowType } from '@/editor/data/model/model';
import { EToolType } from '@/editor/types';

export function getToolType(type: EDoorWindowType) {
  let toolType = EToolType.window;
  switch (type) {
    case EDoorWindowType.window:
      toolType = EToolType.window;
      break;
    case EDoorWindowType.frenchWindow:
      toolType = EToolType.frenchWindow;
      break;
    case EDoorWindowType.singleDoor:
      toolType = EToolType.singleDoor;
      break;
    case EDoorWindowType.doubleDoor:
      toolType = EToolType.doubleDoor;
      break;
    case EDoorWindowType.motherDoor:
      toolType = EToolType.motherDoor;
      break;
  }
  return toolType;
}
